import * as yup from "yup";

export const stepAddressSchema = yup.object().shape({
    name: yup
        .string()
        .required('Campo obbligatorio'),

    locationId: yup
        .string()
        .required('Campo obbligatorio'),

    addressStreet: yup
        .string()
        .required('Campo obbligatorio'),

    addressNumber: yup.number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
});

export const stepContactSchema = yup.object().shape({
    mail: yup.string()
        .email('Deve essere un indirizzo email')
        .required('Campo obbligatorio')
});